<template>
  <div :class="{ 'description-select': true, 'description-select--simple': simple }">
    <div class="menu menu--dropdown description-select__container">
      <div class="description-select__title hide-for-medium">
        <div class="typo-small-title">
          {{ label }}
        </div>
      </div>

      <div :class="{'description-select__values typo-rating': true, 'description-select__values--rating-scale': ratingScale }">
        <div
          v-for="item in items"
          :key="item.label"
          :class="{'description-select__values--disabled': item.value === 'none' }"
        >
          <input
            :id="`${name}_rating_${item.value}`"
            :key="item"
            :checked="item.value === selectedValue"
            :disabled="item.disabled"
            :name="`${name}_rating`"
            type="radio"
            @change="selectItem(item)"
          >
          <label
            class="description-select__rating"
            :for="`${name}_rating_${item.value}`"
          >
            <UseSvg
              v-if="iconName"
              :class="`description-select__indicator ${item.iconClass || ''}`"
              :name="iconName"
            />
            <div class="description-select__label">{{ item.label }}</div>
          </label>
        </div>
      </div>

      <div class="description-select__actions">
        <button
          v-if="removable"
          :aria-label="$t('general.remove')"
          class="button button--small"
          type="button"
          @click="remove"
        >
          <Trash16Svg />
        </button>

        <div class="description-select__actions-end">
          <button
            class="button button--small typo-ignore typo-small"
            type="button"
            @click="cancel"
          >
            {{ $t('general.cancel') }}
          </button>
          <button
            class="button button--small button--inverse typo-ignore typo-small"
            :disabled="selectedValue === null"
            type="button"
            @click="update"
          >
            {{ addText }}
          </button>
        </div>
      </div>

      <div class="description-select__info">
        <div
          v-if="description[0]?.header"
        >
          <div
            v-for="item in description"
            :key="item.header"
          >
            <span class="typo-ignore typo-tiny description-select__header">
              {{ item.header }}
            </span>
            <ul class="description-select__list">
              <li
                v-for="list in item.list"
                :key="list"
                class="typo-ignore typo-tiny"
              >
                {{ list }}
              </li>
            </ul>
          </div>
        </div>
        <div v-else>
          <p
            v-for="line in description"
            :key="line"
            class="typo-ignore typo-tiny"
          >
            {{ line }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import I18n from 'i18n-js';

import UseSvg from '@/components/generic/use_svg.vue';

import Trash16Svg from '@/images/trash-16.svg';

const props = defineProps({
  name: { type: String, required: true },
  label: { type: String, required: true },
  modelValue: { type: [String, Number], default: null },
  items: { type: Array, required: true },
  iconName: { type: String, default: null },
  ratingScale: { type: Boolean, default: false },
  removable: { type: Boolean, default: true },
  simple: { type: Boolean, default: false },
  addText: { type: String, default: () => I18n.t('general.update') }
});
const emit = defineEmits(['update:modelValue', 'cancel', 'remove']);

const selectedValue = ref(props.modelValue || null);

const description = computed(() => {
  if (selectedValue.value === null) return [];
  let item = findItem(selectedValue.value);

  if (item) return item['description'] || [];
  return [];
});

watch(() => props.modelValue, () => selectedValue.value = props.modelValue);

function remove() {
  selectedValue.value = null;
  emit('remove');
}

function cancel() {
  selectedValue.value = props.modelValue;
  emit('cancel');
}

function update() {
  emit('update:modelValue', selectedValue.value);
}

function selectItem(item) {
  selectedValue.value = item.value;
}

function findItem(value) {
  return props.items.find(i => i['value'] === value);
}
</script>
